export { default as walletTracking } from "./wallet";
